import TrashOutlineIcon from '@eduzz/houston-icons/TrashOutline';
import IconButton from '@eduzz/houston-ui/IconButton';
import List from '@eduzz/houston-ui/List';
import React, { Component } from 'react';

import AlpaclassForm from '../../Form/Alpaclass';

interface IProps {
  other: any;
  onRemove: any;
  onEdit?: any;
  index: any;
  offer?: any;
}

interface IStates {
  modal: boolean;
}

class Alpaclass extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = { modal: false };
  }
  otherName = (other: any) => {
    if (other && other.id) {
      return other.method_name;
    }
    return other.name;
  };

  modal = () => {
    this.setState({ modal: !this.state.modal });
  };
  onOk = (newItem: any, old: any) => {
    const { onEdit } = this.props;
    this.setState({ modal: false });
    if (onEdit) {
      onEdit(newItem, old);
    }
  };
  render() {
    const { other } = this.props;
    return (
      <>
        <List.Item>
          <List.Left>
            <img src='/img/alpaclass.svg' width='40' />
          </List.Left>
          <List.Text title={this.otherName(other)} description={other?.url} onClick={() => this.modal()} />

          {other.can_modify && (
            <List.Right>
              <IconButton onClick={() => this.props.onRemove(this.otherName(other), this.props.index)}>
                <TrashOutlineIcon />
              </IconButton>
            </List.Right>
          )}
        </List.Item>
        {this.state.modal && (
          <AlpaclassForm other={other} isModal={true} open={this.state.modal} onClose={this.modal} onOk={this.onOk} offer={this.props.offer} />
        )}
      </>
    );
  }
}

export default Alpaclass;
